import Toast from '@ingka/toast';
import {
  removeFirstMessage,
  selectFirstMessage,
  useAppDispatch,
  useAppSelector,
} from '@lotta/self-service/lottery-fe/data-access-state';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './MessageToast.module.scss';

/* eslint-disable-next-line */
export type MessageToastProps = {};

export const MessageToast: React.FC<MessageToastProps> = () => {
  const dispatch = useAppDispatch();
  const message = useAppSelector(selectFirstMessage);
  const { t } = useTranslation();
  const [showMessage, setShowMessage] = useState(false);

  useEffect(() => {
    // Wait for toast animation to end
    const id = setTimeout(() => {
      setShowMessage(!!message);
    }, 500);

    return () => clearTimeout(id);
  }, [message]);

  const onCloseRequest = useCallback(() => {
    setShowMessage(false);
    dispatch(removeFirstMessage());
  }, [setShowMessage, dispatch]);

  return (
    <Toast
      className={styles['message-toast']}
      text={`${t(message?.key)}`}
      isOpen={showMessage}
      onCloseRequest={onCloseRequest}
    />
  );
};
